import api from '../../../configs/instanceApi';

export const sendCNPJ = (ecIdentity, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.post(url, ecIdentity, config);
};

export const sendCNAE = (ecIdentity, ecBasicData, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/ec-basic-data`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  const payload = {...ecBasicData};
  return api.patch(url, payload, config);
};
